<div class="d-flex align-items-center py-3 flex-wrap gap-3">
    <div *ngIf="showBackButton" class="back-button me-auto">
        <a class="btn btn-back" (click)="onBack()">
            Back
        </a>
    </div>
    <div class="d-flex gap-3 ms-auto">
        <!-- <div class="save-button" *ngIf="!isViewMode">
            <a class="btn btn-save" (click)="onSave()">
                Save
            </a>
        </div> -->
        <div class="next-button" *ngIf="showNextButton">
            <a class="btn btn-next" (click)="onNext()" [ngClass]="{'disabled': nextButtonDisabled}">
                {{ nextButtonText }}
            </a>
        </div>
    </div>
</div>